"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const DefaultIcon_1 = tslib_1.__importDefault(require("./DefaultIcon"));
exports.default = (props) => (React.createElement(DefaultIcon_1.default, Object.assign({}, props, { viewBox: "0 96 960 960" }),
    React.createElement("path", { d: "M120 936v-80h720v80H120Zm240-160v-80h480v80H360ZM120 616v-80h720v80H120Zm240-160v-80h480v80H360ZM120 296v-80h720v80H120Z" })));
